import React, { Component } from "react";
import { ImgTributario } from "../../images/servicios";
import { ModernServicePage } from "../modern";

export class Diagnostico extends Component {
  render() {
    const serviceData = {
      title: "Diagnóstico Tributario",
      subtitle:
        "Realizamos un cumplimiento tributario conforme a la legislación nacional",
      description:
        "Evaluamos y optimizamos el cumplimiento tributario de tu empresa para minimizar riesgos y maximizar beneficios.",
      whatsappMessage:
        "Hola, necesito información sobre diagnóstico tributario",
      features: [
        {
          emoji: "🔍",
          title: "Evaluación Crítica",
          description:
            "Realizar una evaluación crítica, desde el punto de vista tributario de las operaciones desarrolladas por la Sociedad, así como de la documentación de soporte de dichas operaciones por un período determinado, a la luz de la visión de SII.",
        },
        {
          emoji: "📊",
          title: "Grado de Cumplimiento",
          description:
            "Establecer el grado de cumplimiento de las obligaciones tributarias producto de las operaciones desarrolladas por la empresa y determinar si existe alguna desviación entre las prácticas seguidas por la empresa y las normas tributarias vigentes.",
        },
        {
          emoji: "⚠️",
          title: "Identificación de Riesgos",
          description:
            "Identificar posibles riesgos tributarios relacionados con las operaciones de la sociedad o con la forma de documentar las mismas.",
        },
        {
          emoji: "🤝",
          title: "Apoyo Técnico",
          description:
            "Brindar apoyo técnico para evaluar, conjuntamente con la gerencia de la empresa, aquellos aspectos que requieran la adopción de un cambio de criterio.",
        },
        {
          emoji: "🔄",
          title: "Servicio Integral",
          description:
            "Posteriormente, para continuar con un cumplimiento tributario conforme a la legislación nacional, nuestro servicio implica la tercerización de todas las tareas de cumplimiento tributario del día a día.",
        },
        {
          emoji: "👨‍💼",
          title: "Equipo Especializado",
          description:
            "El equipo de impuestos de Contasi pone a su disposición un grupo de profesionales especialistas en impuestos que maximizarán las fortalezas de su departamento financiero.",
        },
      ],
      images: [
        {
          src: ImgTributario,
          alt: "Diagnóstico Tributario Profesional",
        },
      ],
      benefits: [
        "Análisis exhaustivo de cumplimiento tributario",
        "Identificación proactiva de riesgos",
        "Optimización de carga tributaria",
        "Documentación conforme a normativas",
        "Asesoría especializada en SII",
        "Soluciones personalizadas",
        "Seguimiento continuo post-diagnóstico",
      ],
      navigationItems: [
        { id: "feature-0", label: "Evaluación" },
        { id: "feature-1", label: "Cumplimiento" },
        { id: "feature-2", label: "Riesgos" },
        { id: "feature-3", label: "Apoyo Técnico" },
      ],
    };

    return <ModernServicePage {...serviceData} />;
  }
}

export default Diagnostico;
